import { trackStatus, mediaType } from '@bt-react/constants'
import * as Twilio from 'twilio-video'
import PlayIn from '../../../lib/playIn'
import { Role } from '../../constants/roles'
import { ParticipantInformationInterface } from '../docs/syncUi/types'

export interface PresenterTrack {
  kind: string
  status: trackStatus
}

export interface Presenter {
  local: boolean
  name: string
  tracks: Map<string, PresenterTrack>
}

export interface PresenterInfo {
  BTID: string
  role: Role
}

export interface QualityWarning {
  active: boolean,
  closed: boolean
}

export interface RoomReducer {
  dialedInParticipants: string[]
  focusOn: string | null
  screenShareFocus: string | null
  gigTerminationTime?: string
  hasWebcamError: boolean
  isFetchingRoom: boolean
  localSid: string | null
  mediaType: mediaType
  participantInformation: ParticipantInformationInterface[]
  playIn: PlayIn | null
  presenters: Map<string, Presenter>
  participantLookup: Record<Twilio.Participant['sid'], PresenterInfo>
  room: Twilio.Room | null
  dominantSpeaker: string | null
  qualityWarning: QualityWarning
}

export const defaultTrackState: PresenterTrack = {
  kind: '',
  status: trackStatus.UNSTAGED
}

export const defaultPresenterState: Presenter = {
  name: '',
  tracks: new Map(),
  local: false
}

const defaultState: RoomReducer = {
  dialedInParticipants: [],
  focusOn: null,
  screenShareFocus: null,
  gigTerminationTime: undefined,
  hasWebcamError: false,
  isFetchingRoom: false,
  localSid: null,
  mediaType: mediaType.WEBCAM,
  participantInformation: [],
  playIn: null,
  presenters: new Map(),
  room: null,
  participantLookup: {},
  dominantSpeaker: null,
  qualityWarning: {active: false, closed: false}
}

export default defaultState
